import { VND_UNIT } from '../../../constants'
import { getChartKey } from '../../../store/helper'

export const handleChartDataByUnit = (chartData, unit, convertValue) => {
  if (unit !== VND_UNIT) return chartData

  return chartData.map((item) => {
    return Object.keys(item).reduce((prev, cur) => {
      return {
        ...prev,
        [cur]:
          cur === 'year'
            ? item[cur]
            : handleLineAreaData(item[cur], convertValue, item.year),
      }
    }, {})
  })
}

const handleLineAreaData = (data, convertValue, year) => {
  if (Array.isArray(data)) {
    return data.map((item) =>
      convertValue({ value: item, year, exchangeRateType: 'lastDayRate' }),
    )
  }

  return convertValue({ value: data, year, exchangeRateType: 'lastDayRate' })
}

export const getListTooltip = (titleById, data, activeRow) => {
  return Object.keys(titleById).map((portfolioKey) => {
    return {
      label: titleById[portfolioKey],
      median: data[getChartKey(portfolioKey, activeRow, 'lineKey')],
      range: data[getChartKey(portfolioKey, activeRow, 'areaKey')],
      rowId: activeRow,
    }
  })
}
